export middlewareNormalizeDataGenerator from './middlewareNormalizeDataGenerator';
export middlewareReStructureResponses from './middlewareReStructureResponses';
export middlewareStructureGenerator from './middlewareStructureGenerator';



// WEBPACK FOOTER //
// ./~/virgo/src/middlewares/index.js